import { toNodeNumberIdentity } from './node-number-identity';

/**
 * How a node number is NAMED inside an error message (PSTUDIO-3990).
 *
 * The JSON-field errors interpolated the raw value as `${nodeNumber ?? 'unknown'}`,
 * which only guards null and undefined. A cleared cell holds `''`, so the message
 * ended mid-sentence — "…, Node #: , please enter a valid JSON object." — and a
 * 0 was named as though it were a real node number. The ticket's rule is that an
 * error must describe the number as missing rather than report a specific false
 * value, so anything the shared predicate rejects reads as "unknown".
 *
 * Extracted rather than inlined because the same interpolation appears at three
 * call sites in `validateAndSync`, and a store method that large is not
 * unit-testable on its own.
 */
export const nodeNumberDisplayLabel = (nodeNumber: unknown): string => {
  const identity = toNodeNumberIdentity(nodeNumber);
  return identity === undefined ? 'unknown' : String(identity);
};
